import { BaseService } from '../base.service';

export class RestaurantQuestionsService extends BaseService {
  static get resourceEndpoint() {
    return 'owners/restaurant_administrators/questions';
  }
}